<template>
    <div class="content-window-container"
         v-observe-visibility="visibilityChanged"
         :id="pageID">
        <div id="sc-page-waves"></div>

        <div class="container container-main clear">
            <div class="home-text clear will-animate" data-ani="animated fadeInLeft">
                <div class="window-title">
                    <span class="red">Seal </span>
                    <span> SC</span>
                </div>
                <div class="window-content">{{$t('Page.Home.Content')}}</div>
                <div class="window-content-sub">{{$t('Page.Home.ContentSub')}}</div>
            </div>
            <div class="home-banner clear will-animate" data-ani="animated fadeInRight">
                <img src="../assets/page/home/banner.png"/>
            </div>
        </div>
    </div>
</template>

<script>
  import {pageMounted, basicPageMethods} from "../js/common"
  import {scNamespace} from "../js/scNamespace"
  import Is from 'is_js'
  import {drawWaves} from "../js/waves";

  export default {
    name: "home",
    mounted: pageMounted,
    data() {
      return {
        pageID: scNamespace.PAGE.HOME.id
      }
    },
    methods: {
      ...basicPageMethods(),
      localMounted() {
        this.$nextTick(_=> {
          if(!Is.mobile()) {
            drawWaves()
          }
        })
      }
    }
  }
</script>

<style scoped>
    .content-window-container {
        position: relative;
        overflow: hidden;
    }
    .container .home-text {
        padding-top: 120px;
        width: 50%;
        float: left;
        text-align: center;
    }

    .container .home-banner {
        position: relative;
        width: 540px;
        height: 510px;
        float: right;
        text-align: right;
    }

    .container .home-banner img {
        width: 100%;
        /*margin-top: 10%;*/
    }

    .window-title {
        font-size: 70px;
        line-height: 70px;
        margin-bottom: 20px;
        font-weight: 500;
        color: #161920;
    }

    .window-title span.red {
        color: #ba2713;
    }

    .window-content {
        font-size: 24px;
        margin-bottom: 0;
    }

    .window-content-sub {
        font-weight: 300;
        max-width: 500px;
        text-align: center;
        margin: 0 auto;
        margin-top: 20px !important;
    }

    @media screen and (max-width: 1100px) {
        .container .home-banner {
            position: relative;
            width: 440px;
            /*height: 510px;*/
            float: right;
            text-align: right;
        }

        .container .home-banner img {
            margin-top: 10%;
        }

    }

        @media screen and (max-width: 900px) and (max-height: 768px) {
        .container .home-text {
            width: 100%;
            padding-top: 0;
        }

        .container .home-banner {
            /*width: auto;*/
            /*height: 240px;*/
            float: none;
            margin: 0 auto;
            margin-top: 20px;
            clear: both;
            text-align: center;
        }

        /*.container .home-banner img {*/
            /*width: auto;*/
            /*height: 100%;*/
        /*}*/
    }

    @media screen and (max-width: 900px) and (min-height: 1024px) {
        .container .home-text {
            width: 100%;
            padding-top: 0;
        }

        /*.container .home-banner {*/
            /*width: 60%;*/
            /*float: none;*/
            /*margin: 0 auto;*/
            /*padding-top: 40px;*/
            /*clear: both;*/
        /*}*/

        /*.container .home-banner img {*/
            /*width: 100%;*/
            /*height: auto;*/
        /*}*/
    }

    @media screen and (max-width: 900px) and (max-height: 1000px) {
        .container .home-text {
            width: 100%;
            padding-top: 10px;
        }

        .container .home-banner {
            width: 230px;
            height: 180px;
            float: none;
            margin: 0 auto;
            clear: both;
        }

        .container .home-banner img {
            width: 100%;
            height: auto;
        }

        .window-title {
            font-size: 60px;
            line-height: 60px;
            margin-bottom: 20px;
            font-weight: 500;
        }

        .window-content {
            font-size: 18px !important;
            line-height: 30px;
        }

        .window-content-sub {
            font-weight: 300;
            max-width: 500px;
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
</style>

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